import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation ,useNavigate} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const HR = () => {
  const names = ['Staff Attendance', 'Resident Checkin/Checkout', 'Salary Generation'];
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);
                 const hasModulePermission = (moduleName) => {
                   const modulePermission = permissions.find(
                     permission => permission.ModuleName === moduleName
                   );
                   
                   if (!modulePermission) return false;
               
                   return (
                     modulePermission.AddRec === "1" ||
                     modulePermission.EditRec === "1" ||
                     modulePermission.DeleteRec === "1" ||
                     modulePermission.ViewRec === "1"
                   );
                 };


  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container spacing={2}>
          {hasModulePermission("Staff Attendance") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="Staff Attendance"
            />)}

           {hasModulePermission("Resident Checkin/Checkout") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="Resident Checkin/Checkout"
            />)}

           {hasModulePermission("Salary Generation") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="Salary Generation"
            />)}
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>  
         
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default HR;